export enum FilterFieldsKeys {
  monthFrom = 'monthFrom',
  monthTo = 'monthTo',
  distributorAgentId = 'distributorAgentId',
  programName = 'programName',
  pfhNo = 'pfhNo',
  rebateMode = 'rebateMode',
}

export interface FilterFields {
  [FilterFieldsKeys.monthFrom]: string;
  [FilterFieldsKeys.monthTo]: string;
  [FilterFieldsKeys.distributorAgentId]: string;
  [FilterFieldsKeys.programName]: string;
  [FilterFieldsKeys.pfhNo]: string;
  [FilterFieldsKeys.rebateMode]: string;
}
